import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UserRecordsResults } from '®shared/user';

export const STATE_FEATURE_LIST_OWNERS = 'listOwners';

export interface UserSearchState {
  searchTerm: string | null;
  searchResults: UserRecordsResults | null;
  isLoading: boolean;
  error: any | null;
}

export const USER_SEARCH_INITIAL_STATE: UserSearchState = {
  searchTerm: null,
  searchResults: null,
  isLoading: false,
  error: null,
};

export interface ListOwnersEditorState {
  isModalShown: boolean;
  listId: string | null;
  isSaving: boolean;
  savingError: any;
}

export const LIST_OWNERS_EDITOR_INITIAL_STATE: ListOwnersEditorState = {
  isModalShown: false,
  listId: null,
  isSaving: false,
  savingError: null,
};

export interface ListOwnersState {
  search: UserSearchState;
  listOwnersEditor: ListOwnersEditorState;
}

export const LIST_OWNERS_INITIAL_STATE: ListOwnersState = {
  search: USER_SEARCH_INITIAL_STATE,
  listOwnersEditor: LIST_OWNERS_EDITOR_INITIAL_STATE,
};

export function getInitialListOwnersState(): ListOwnersState {
  return LIST_OWNERS_INITIAL_STATE;
}

export const selectListOwnersState = createFeatureSelector<ListOwnersState>(
  STATE_FEATURE_LIST_OWNERS,
);

export const selectUserSearchState = createSelector(
  selectListOwnersState,
  (state: ListOwnersState) => state.search,
);

export const selectListOwnersEditorState = createSelector(
  selectListOwnersState,
  (state: ListOwnersState) => state.listOwnersEditor,
);
